import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-impact-tracker-hexagons',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './hexagons.component.html',
})
export class HexagonsComponent {}
